/** The AI feature builder dialog: closed, new plugin (null) or refining one. */
import { create } from 'zustand';
import type { InstalledPlugin } from '@nexus/plugins';

export const useBuilder = create<{
  target: InstalledPlugin | null | undefined;
  open: (plugin: InstalledPlugin | null) => void;
  close: () => void;
}>((set) => ({
  target: undefined,
  open: (plugin) => set({ target: plugin }),
  close: () => set({ target: undefined }),
}));
